import React from 'react';
import { sanitizeText } from './ShareButtonUtils';
import Icon from 'buyside/components/presentation/Icon/icon';
import LinkedInIcon from 'buyside/svgs/social_media/linked_in_icon.svg';
import styles from './shareButtonStyles';

const LinkedInButton = ({ shareText }) => {
  return (
    <div>
      <a
        target="_blank"
        href={`https://www.linkedin.com/shareArticle?mini=true&url=${sanitizeText(shareText)}`}
      >
        <Icon type={LinkedInIcon} className={styles.shareButton} />
      </a>
    </div>
  );
};

export default LinkedInButton;
